import { useState, useEffect, useContext, useRef } from "react";
import clsx from "clsx";
import { useSection } from "@tree-company/tree-query";
import { DEBUG } from "../../debug";
import { LocaleContext } from "../../app";

export const hasFourDigits = (v) => v !== null && String(v).length === 4;

export function NumberInput({ question, className }) {
  const { value, placeholder, title } = useSection(question);
  const { translate } = useContext(LocaleContext);
  const [inputValue, setInputValue] = useState(value ?? "");
  const [showError, setShowError] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!DEBUG) return;
    if (value !== null) setInputValue(value);
  }, [value]);

  return (
    <div
      className={clsx("card", "optin-field", "optin-field--number", className)}
    >
      <label className="optin-field__label optin-field__column">
        <span className="optin-field__label-text card-title">{title}</span>
        <input
          ref={inputRef}
          type="number"
          className="optin-field__input"
          name={question.key}
          value={inputValue}
          placeholder={placeholder || ""}
          required
          min={question.settings.min}
          max={question.settings.max}
          onInput={(e) => {
            if (e.target.value.length > 4) {
              e.target.value = e.target.value.slice(0, 4);
            }
            if (showError && e.target.checkValidity()) {
              setShowError(false);
            }
          }}
          onInvalid={() => setShowError(true)}
          onChange={(e) => {
            const val = e.target.value;
            setInputValue(val);
            question.value = hasFourDigits(val) ? Number(val) : null;
          }}
        />
        <p
          className={clsx("optin-field__error", {
            "optin-field__error--visible": showError,
          })}
        >
          {translate("optin.error.number_input")}
        </p>
      </label>
    </div>
  );
}
